var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 31,
    fill: "#DBEFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 20C28.895 20 28 20.895 28 22H20C18.895 22 18 22.895 18 24V33C18 34.105 18.895 35 20 35H42C43.105 35 44 34.105 44 33V24C44 22.895 43.105 22 42 22H34C34 20.895 33.105 20 32 20H30ZM31 31C31.552 31 32 31.448 32 32C32 32.552 31.552 33 31 33C30.448 33 30 32.552 30 32C30 31.448 30.448 31 31 31ZM18 36.4434V40C18 41.105 18.895 42 20 42H42C43.105 42 44 41.105 44 40V36.4434C43.409 36.7874 42.732 37 42 37H20C19.268 37 18.591 36.7874 18 36.4434Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.70c2f6beba871ca8dcf6c8c568ec6433.svg";
export { ForwardRef as ReactComponent };